const NAMESPACE = 'ReturnToCheckpoint';
Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck[NAMESPACE] = {

  template() {
    const unitSystemKey = (Monet.Session.User.unitSystem === 'NON_METRIC') ?
      'Greenmile.UnitMetrics.milesAbreviationParentheses' : 'Greenmile.UnitMetrics.kilometersAbreviationParentheses';
    const labelDistance = Monet.I18n.getResourcesByKey('event.arrivaldeparture.distance', Monet.I18n.getResourcesByKey(unitSystemKey));

    return {
      tag: 'div',
      items: [
        {
          items: [
            {
              items: [
                {
                  attributes: {
                    'id': 'location-type-field',
                    class: 'modelAttribute mandatory',
                  },
                },
                {
                  items: [
                    {
                      'tag': 'input',
                      attributes: {
                        "type": 'radio',
                        "name": 'distanceTime',
                        "id": 'distance',
                        "class": 'modelAttribute radioField mandatory',
                        "checked": 'true',
                      },
                    },
                    {
                      tag: 'label',
                      'items': [
                        {
                          "tag": 'span',
                          "html": labelDistance,
                        },
                      ],
                    },
                    {
                      'tag': 'input',
                      attributes: {
                        "type": 'number',
                        "step": '1',
                        "id": 'distance-value',
                        "class": 'modelAttribute radioField mandatory',
                      },
                    },
                  ],
                },
                {
                  items: [
                    {
                      'tag': 'input',
                      attributes: {
                        "type": 'radio',
                        "name": 'distanceTime',
                        "id": 'time',
                        "class": 'modelAttribute radioField mandatory',
                      },
                    },
                    {
                      tag: 'label',
                      'items': [
                        {
                          "tag": 'span',
                          "html": Monet.I18n.getResourcesByKey('event.unplanned.timeminutes'),
                        },
                      ],
                    },
                    {
                      'tag': 'input',
                      attributes: {
                        "type": 'number',
                        "step": '1',
                        "id": 'time-value',
                        "class": 'modelAttribute radioField mandatory',
                        "disabled": "true",
                      },
                    },
                  ],
                },
              ],
              attributes: {
                class: 'controls',
              },
            },

            {
              items: [
                {
                  tag: 'input',
                  attributes: {
                    type: 'checkbox',
                    id: 'sendifallcustomersattended',
                    'class': 'modelAttribute checkbox',
                  },
                },
                {
                  tag: 'span',
                  html: Monet.I18n.getResourcesByKey('event.arrivetocheckpoint.sendifallcustomersattended'),
                },
              ],
              attributes: {
                class: 'controls',
                id: 'sendifallcustomersattended',
              },
            }
          ],
          attributes: {
            class: 'control-group arrive-checkpoint'
          },
        },
        {
          tag: 'input',
          attributes: {
            type:'hidden',
            name: 'namespace',
            value: NAMESPACE
          }
        }
      ],
    };
  },

  assignParameter(jsonParam) {

    const lookupLocationType = new Monet.UI.Fields.Render({
        name: 'locationType',
        label: Monet.I18n.getResourcesByKey('stop.locationType.description'),
        mandatory: false,
        type: 'LOOKUP',
        lookupEntity: 'LocationType',
        lookupEntityColumn: 'description',
      }, 'EventCheckArriveToCheckPoint').render();

    const getFormatedValueByI18nLocale = (value) => {
      const formatter = new Monet.Format.DISTANCE(value);
      let formattedValue = null;

      if (Monet.Session.User.unitSystem === "NON_METRIC") {
        formattedValue = formatter.convertMetersToMiles().format().getValue();
      } else {
        formattedValue = formatter.convertMetersToKilometers().format().getValue();
      }

      return formattedValue;
    };

    const content = document.querySelector('#Event #location-type-field');
    content.appendChild(lookupLocationType.rootEl);

    jsonParam = jsonParam ? JSON.parse(jsonParam) : {};

    if(jsonParam.locationTypeId) {
      lookupLocationType.setValue({id: jsonParam.locationTypeId});
    }

    const radioDistance =  document.querySelector('.arrive-checkpoint #distance' );
    const inputDistance =  document.querySelector('.arrive-checkpoint #distance-value' );
    const radioTime =  document.querySelector('.arrive-checkpoint #time' );
    const inputTime =  document.querySelector('.arrive-checkpoint #time-value' );

    const disableFields = ({ toDisable, toEnable } ) => {
      toDisable.value = '';
      toDisable.disabled = true;
      toEnable.disabled = false;
    };
    const disableTimeFields = () => {
      disableFields({ toDisable: inputTime, toEnable: inputDistance } );
    }
    const disableDistanceFields = () => {
      disableFields({ toDisable: inputDistance, toEnable: inputTime} );
    };

    radioDistance.addEventListener('click', disableTimeFields );
    radioTime.addEventListener('click', disableDistanceFields);

    if(jsonParam.minimumDistanceMeters) {
      disableTimeFields();
      radioDistance.checked = true;
      inputDistance.value = getFormatedValueByI18nLocale(jsonParam.minimumDistanceMeters);

    } else if (jsonParam.minimumTimeToArrivalInMinutes) {
      disableDistanceFields();
      radioTime.checked = true;
      inputTime.value = jsonParam.minimumTimeToArrivalInMinutes;
    }

    document.querySelector('input#sendifallcustomersattended' ).checked = !!jsonParam.sendOnlyWhenAllCustomersAttended;


  },

  retrieveParameter() {
    const data = {
      locationTypeId: document.querySelector('#EventCheckArriveToCheckPoint_locationType #locationType_id' ).value,
      sendOnlyWhenAllCustomersAttended: document.querySelector('input#sendifallcustomersattended' ).checked
    };

    const radioDistance =  document.querySelector('.arrive-checkpoint #distance' );
    const radioTime =  document.querySelector('.arrive-checkpoint #time' );

    if(radioDistance.checked) {

      const inputDistance =  document.querySelector('.arrive-checkpoint #distance-value' );
      const field = new Monet.UI.Fields.MilesOrKilometers();
      data.minimumDistanceMeters = field.convertToMetricSystem(inputDistance.value)*1000;

    } else if (radioTime.checked) {
      const input =  document.querySelector('.arrive-checkpoint #time-value' );
      data.minimumTimeToArrivalInMinutes = input.value;
    }


    return JSON.stringify(data);
  },

  validateParameter(validation) {
    const locationTypeId = document.querySelector('#EventCheckArriveToCheckPoint_locationType #locationType_id' ).value;
    const locationTypeLookup = document.querySelector('.arrive-checkpoint #location-type-field' );
    let inputFieldNotFilled = '';

    const radioDistance =  document.querySelector('.arrive-checkpoint #distance' );
    const inputDistance =  document.querySelector('.arrive-checkpoint #distance-value' );

    const radioTime =  document.querySelector('.arrive-checkpoint #time' );
    const inputTime =  document.querySelector('.arrive-checkpoint #time-value' );
    const ERROR_CLASS = ' error';

    inputDistance.className = inputDistance.className.replace(ERROR_CLASS, '')
    inputTime.className = inputTime.className.replace(ERROR_CLASS, '');
    locationTypeLookup.className = locationTypeLookup.className.replace(ERROR_CLASS, '');

    if( !locationTypeId ) {
      validation.errorMessages.push(
        Monet.Form.Messages.mountErrorMessageObject(
          `${Monet.I18n.getResourcesByKey('stop.locationType.description')} ${Monet.I18n.getResourcesByKey('error.isrequired')}` )
      );
      validation.status = false;
      locationTypeLookup.className += ERROR_CLASS;
    }

    if( radioDistance.checked && !inputDistance.value ) {
      inputFieldNotFilled = 'Reports.Description.Distance';
      inputDistance.className += ERROR_CLASS;
    } else if (radioTime.checked && !inputTime.value) {
      inputFieldNotFilled = 'event.unplanned.timeminutes';
      inputTime.className += ERROR_CLASS;
    }

    if(inputFieldNotFilled) {
      validation.errorMessages.push(
        Monet.Form.Messages.mountErrorMessageObject(
          `${Monet.I18n.getResourcesByKey(inputFieldNotFilled)} ${Monet.I18n.getResourcesByKey('error.isrequired')}` )
      );
      validation.status = false;
    }

    return validation;

  }
};
